import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=c26aeb58&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=c26aeb58&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c26aeb58')) {
      api.createRecord('c26aeb58', component.options)
    } else {
      api.reload('c26aeb58', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=c26aeb58&", function () {
      api.rerender('c26aeb58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/PageHeader.vue"
export default component.exports